import React from "react";
import TaskFormBoolean from "./boolean";
import PriorityIcon from "@coworker/reusable/svg/priority-exclamation-sign.svg?react";
import { Trans } from "@coworker/locales";

interface ConfigWidgetProps {
  title: React.ReactNode;
  icon: React.ReactNode;
  testId: string;
  overridePadding: string;
  titleMargin: string;
}

interface TaskPriorityWidgetProps {
  isPriority: boolean;
  togglePriority: () => void;
}

function TaskPriorityWidget({
  isPriority,
  togglePriority,
}: TaskPriorityWidgetProps) {
  const config: ConfigWidgetProps = {
    icon: <PriorityIcon />,
    overridePadding: "0 24px",
    title: <Trans>priorityString</Trans>,
    testId: "priorityCheckbox",
    titleMargin: "14px",
  };
  return (
    <TaskFormBoolean
      value={isPriority}
      onChange={togglePriority}
      conf={config}
    />
  );
}

export default React.memo(TaskPriorityWidget);
